// extracted by mini-css-extract-plugin
module.exports = {"spotListCtaThumbnail":"SpotListCTAThumbnail_spotListCtaThumbnail__QCPcZ","spotListCtaThumbnail--tooltip":"SpotListCTAThumbnail_spotListCtaThumbnail--tooltip__gi1gO"};